import { safeAreaPadding } from "@/helpers/safeArea";

export function SafePaddingContainer({ 
    children, 
    orientation,
    className = ""
}: { 
    children: React.ReactNode;
    orientation?: "header" | "footer" | "vertical-only" | "neither";
    className?: string;
}) {
    return (
        <div
            className={`w-full ${className}`}
            style={{
                paddingTop: orientation === "header" || orientation === "vertical-only" ? safeAreaPadding("6vw", "top") : undefined,
                paddingBottom: orientation === "footer" || orientation === "vertical-only" ? safeAreaPadding("6vw", "bottom") : undefined,
                paddingLeft: orientation !== "vertical-only" ? safeAreaPadding("6vw", "left") : undefined,
                paddingRight: orientation !== "vertical-only" ? safeAreaPadding("6vw", "right") : undefined,
            }}
        >
            {children}
        </div>
    );
}